export const Switch = {
  baseStyle: {},
  variants: {
    primary: {
      track: {
        _checked: {
          bg: 'brand.accent',
          _hover: {
            bg: 'brand.accent',
          },
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    },
  },
  // The default variant values
  defaultProps: {
    variant: 'primary',
  },
}
